export default __webpack_public_path__ + "static/media/bg5.7fa95a5a.jpg";